var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95833 17.9167C4.01667 17.9167 0 13.9 0 8.95833C0 4.01667 4.01667 0 8.95833 0C13.9 0 17.9167 4.01667 17.9167 8.95833C17.9167 13.9 13.9 17.9167 8.95833 17.9167ZM8.95833 1.25C4.70833 1.25 1.25 4.70833 1.25 8.95833C1.25 13.2083 4.70833 16.6667 8.95833 16.6667C13.2083 16.6667 16.6667 13.2083 16.6667 8.95833C16.6667 4.70833 13.2083 1.25 8.95833 1.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 11.9417C6.44167 11.9417 6.28333 11.8833 6.15833 11.7583C5.91667 11.5167 5.91667 11.1167 6.15833 10.875L10.875 6.15833C11.1167 5.91667 11.5167 5.91667 11.7583 6.15833C12 6.4 12 6.8 11.7583 7.04167L7.04167 11.7583C6.925 11.8833 6.75833 11.9417 6.6 11.9417Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3167 11.9417C11.1583 11.9417 11 11.8833 10.875 11.7583L6.15833 7.04167C5.91667 6.8 5.91667 6.4 6.15833 6.15833C6.4 5.91667 6.8 5.91667 7.04167 6.15833L11.7583 10.875C12 11.1167 12 11.5167 11.7583 11.7583C11.6333 11.8833 11.475 11.9417 11.3167 11.9417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.de6ac4f837852a55ee9865b21a191afa.svg";
export { ForwardRef as ReactComponent };